<template>
  <b-container>
    <b-row>
      <b-col cols="3">
        <b-button variant="info" size="sm" @click="$router.go(-1)"
          >Vissza</b-button
        >
      </b-col>
      <b-col cols="6">
        <h1 class="text-center mb-5">Rögzített adatlapjaim</h1>
      </b-col>
    </b-row>
    <b-pagination-nav
      :number-of-pages="calculatePages()"
      :link-gen="pageLink"
      aria-controls="forms-table"
      align="fill"
      use-router
    ></b-pagination-nav>
    <b-table
      id="forms-table"
      striped
      hover
      :fields="fields"
      :items="getForms"
      :busy.sync="tableBusy"
      :current-page="currentPage"
      stacked="md"
    >
      <template v-slot:cell(icons)="data">
        <span class="show-icon" @click="viewForm(data.item.id)"
          ><b-icon icon="eye-fill" scale="1.6"></b-icon
        ></span>

        <span
          class="edit-icon ml-4"
          :class="{ 'disabled-icon': !data.item.editable }"
          @click="updateForm(data.item.id, data.item.editable, $event)"
        >
          <b-icon icon="pencil" scale="1.6"></b-icon>
        </span>
        <span v-if="data.item.long_talk">
          <span class="long-talk-icon ml-3" :id="'long-talk-' + data.item.id">
            <b-icon
              icon="exclamation-triangle-fill"
              scale="1.6"
              variant="danger"
            ></b-icon>
          </span>
          <b-tooltip
            :target="'long-talk-' + data.item.id"
            variant="warning"
            triggers="hover"
          >
            Ez a beszélgetés nagyon hosszú.
          </b-tooltip>
        </span>
      </template>
    </b-table>
    <b-pagination-nav
      :number-of-pages="calculatePages()"
      :link-gen="pageLink"
      aria-controls="forms-table"
      align="fill"
      use-router
    ></b-pagination-nav>
  </b-container>
</template>

<script>
import FormService from '@/services/FormService'

export default {
  name: 'forms-overview',
  data() {
    return {
      tableBusy: false,
      totalRows: 0,
      fields: [
        {
          key: 'id',
          label: 'sorszám',
        },
        {
          key: 'type',
          label: 'rögzítés típusa',
        },
        {
          key: 'report_time',
          label: 'hívás eleje',
        },
        {
          key: 'end_report_time',
          label: 'hívás vége',
        },
        {
          key: 'crisis',
          label: 'krízis',
        },
        {
          key: 'suicide',
          label: 'szuicid',
        },
        {
          key: 'icons',
          label: 'megtekintés',
        },
      ],
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.$route.query.p || 1
      },
      set() {},
    },
  },
  methods: {
    getForms(ctx) {
      const service = new FormService()
      const formsLoading = service.get(
        ctx.currentPage,
        this.$session.get('token')
      )
      return formsLoading
        .then((response) => {
          this.totalRows = response.total_count
          return response.forms.map((formWithProperties) => {
            const { form, properties } = formWithProperties
            return {
              id: form.id.year + '-' + form.id.officeId + '-' + form.id.id,
              type: this.translateType(form.type),
              report_time: form.reportTime,
              end_report_time: form.endReportTime,
              crisis: this.translateLogical(form.crisis),
              suicide: this.translateLogical(form.suicide),
              editable: properties.editable,
              long_talk: properties.long_talk,
            }
          })
        })
        .catch((error) => {
          this.$modal.show('dialog', {
            text: '<div style="text-align: center"><strong>Hiba történt az űrlapok listázásánal. Próbálja később.</strong></div>',
            buttons: [{ title: 'Oké' }],
            transition: 'fade',
          })
          return []
        })
    },
    translateType(type) {
      return type == 'adequate' ? 'adekvát' : 'inadekvát'
    },
    translateLogical(state) {
      return state === true ? 'igen' : 'nem'
    },
    viewForm(id) {
      this.$router.push({ name: 'FormView', params: { id } })
    },
    updateForm(id, editable, $event) {
      if (!editable) return
      this.$store.commit('setFormId', '')

      if ($event.metaKey || $event.ctrlKey) {
        const routeData = this.$router.resolve({ name: 'Home', query: { id } })
        window.open(routeData.href, '_blank')
      } else {
        this.$router.push({ name: 'Home', query: { id } })
      }
    },
    pageLink(page) {
      return page === 1 ? '?' : `?p=${page}`
    },
    calculatePages() {
      return Math.ceil(this.totalRows / 20) || 1
    },
  },
}
</script>
<style scoped>
.show-icon,
.edit-icon {
  cursor: pointer;
}

.disabled-icon {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>
